import { api } from "./client";
import type { Project } from "../types";

export async function listProjects(search?: string): Promise<Project[]> {
  const { data } = await api.get<Project[]>("/projects", {
    params: search ? { search } : undefined,
  });
  return data;
}

export async function getProject(id: string): Promise<Project> {
  const { data } = await api.get<Project>(`/projects/${id}`);
  return data;
}

export interface CreateProjectInput {
  drug_api_name: string;
  extra_descriptors?: string[];
}

export interface UpdateProjectDescriptorsInput {
  extra_descriptors: string[];
}

export async function createProject(input: CreateProjectInput): Promise<Project> {
  const { data } = await api.post<Project>("/projects", input);
  return data;
}

export async function updateProjectDescriptors(
  id: string,
  body: UpdateProjectDescriptorsInput,
): Promise<Project> {
  const { data } = await api.patch<Project>(`/projects/${id}/descriptors`, body);
  return data;
}

export async function deleteProject(id: string): Promise<void> {
  await api.delete(`/projects/${id}`);
}

export async function startSearch(id: string): Promise<{ job_id: string }> {
  const { data } = await api.post<{ job_id: string }>(`/projects/${id}/search`, {});
  return data;
}
